import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cos-form-item-detail cos-form-item-input-detail" }
const _hoisted_2 = ["title"]

import { computed } from 'vue'


const __default__ = { name: 'CosInputView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    cosDes: {}
  },
  setup(__props: any) {

const props = __props

const valuePage = computed(() => {
  let txt = props.value == null || props.value === '' ? '--' : props.value.toString()
  if (props.cosDes || props.cosDes === 0) {
    txt += ` - ${props.cosDes}`
  }
  return txt
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", { title: valuePage.value }, _toDisplayString(valuePage.value), 9, _hoisted_2)
  ]))
}
}

})